import React, { useState, useEffect } from 'react'

export default function QuoteForm(props) {
  let [radio, setRadio] = useState(null);
  let [info, setInfo] = useState(null);
  let [status, setStatus] = useState(null);
  let [submitting, setSubmitting] = useState(false);
  const radioInfo = {
    graphicdesign: <HowToQuoteGraphicDesign />,
    website: <HowToQuoteWebDev />,
    logodesign: <HowToQuoteLogoDesign />,
    other: <HowToQuoteOther />
  }

  useEffect(() => {
    setInfo(null)
  }, [radio])

  const showInfo = () => {
    setInfo(radioInfo[radio?.value]);
  }

  const onSubmit = async (e) => {
    e.preventDefault();
    const form = e.currentTarget;
    let source = new URLSearchParams(new FormData(form));
    source.append('subject', 'Quote Requested!')

    let formData = new FormData(form);
    if (!formData.get('name') && !formData.get('return') && !formData.get('content') && !radio) {
      setStatus({ type: 'error', message: "Missing required fields" })
    } else {
      setSubmitting(true);
      setStatus(null);
      try {
        let resp = await fetch('https://api.kylediggs.com/api/email/send', {
          method: 'POST',
          body: source,
        }).then(resp => resp.text());

        if (resp === "ok") {
          setStatus({ type: 'success', message: "Email sent successfully!" });
          form.reset();
          setRadio(null);
        } else {
          setStatus({ type: 'error', message: "Something went wrong. Please try again." });
        }
      } catch {
        setStatus({ type: 'error', message: "Network error. Please check your connection and try again." });
      } finally {
        setSubmitting(false);
      }
    }
  }

  return (
    <React.Fragment>
      <form className="quote form" onSubmit={(e) => onSubmit(e)}>
        {status?.type === 'error' ?
          <div className="status-container">
            <p className="status danger">
              <i className="fas fa-heart-broken"></i> {status.message}
            </p>
            <div className="close" onClick={() => setStatus(null)}>
              <i className="far fa-times"></i>
            </div>
          </div>
          : status?.type === 'success' ?
            <div className="status-container">
              <p className="status ok">
                <i className="fas fa-mailbox"></i> {status.message}
              </p>
              <div className="close" onClick={() => setStatus(null)}>
                <i className="far fa-times"></i>
              </div>
            </div>
            : ""}
        <input name="name" type="text" placeholder="Name*" required></input>
        <input name="return" type="email" placeholder="Email Address*" required></input>
        <p><strong>What do you need done?</strong></p>
        <textarea name="content" placeholder="Your Message*" />
        <div className="upload-container">
          <div className="info">
            <p><strong>If you have prepared assets:</strong></p>
            <p>Please include links to your files in your message.</p>
          </div>
        </div>
        <div className="upload-container">
          <p><strong>Project Type*:</strong></p>
          <button onClick={(e) => showInfo()} className={radio !== null ? "button clean quotes" : "button clean quotes hide"} type="button"><i className="far fa-info-circle"></i> How are quotes calculated?</button>
        </div>
        <div className="radio-container">
          <label htmlFor="graphicdesign"><input type="radio" onChange={(e) => setRadio(e.target)} name="primary_interest" id="graphicdesign" value="graphicdesign" required />
            Graphic Design</label>
          <label htmlFor="website"><input type="radio" onChange={(e) => setRadio(e.target)} name="primary_interest" id="website" value="website" required />
            Web Development</label>
          <label htmlFor="logodesign"><input type="radio" onChange={(e) => setRadio(e.target)} name="primary_interest" id="logodesign" value="logodesign" required />
            Logo Design</label>
          <label htmlFor="other"><input type="radio" onChange={(e) => setRadio(e.target)} name="primary_interest" id="other" value="other" required />
            Other</label>
        </div>
        {info ? info : ""}
        <button className="submit button purple" disabled={submitting}>{submitting ? "Sending..." : "Submit"}</button>
      </form>
    </React.Fragment>
  )
}

export function HowToQuoteGraphicDesign() {
  return (
    <React.Fragment>
      <p>Graphic Design is charged at $65/hour</p>
    </React.Fragment>
  )
}

export function HowToQuoteWebDev() {
  return (
    <React.Fragment>
      <p>Web Development is charged at $90/hour</p>
    </React.Fragment>
  )
}

export function HowToQuoteLogoDesign() {
  return (
    <React.Fragment>
      <p>Logo Designs are charged at $250 per logo sample requested</p>
    </React.Fragment>
  )
}

export function HowToQuoteOther() {
  return (
    <React.Fragment>
      <p>Misc tasks are usually charged on a per project basis. Reach out and I'll get back to you with a quote!</p>
    </React.Fragment>
  )
}


